console.log('VARIANT IMAGE FIX LOADED');

(function ($) {

  function updateVariantImage() {
    var $product = $('.product').first();
    if (!$product.length) {
      console.log('NO PRODUCT WRAPPER');
      return;
    }

    var selectedOptions = [];

    $product.find('.form__control input:checked, .form__control select').each(function () {
      selectedOptions.push($(this).val());
    });

    console.log('SELECTED OPTIONS:', selectedOptions);

    var productData = $product.data('product');

    if (!productData || !productData.variants) {
      console.log('NO PRODUCT DATA FOUND');
      return;
    }

    var variant = productData.variants.find(function (v) {
      return v.options.every(function (option, index) {
        return option === selectedOptions[index];
      });
    });

    console.log('MATCHED VARIANT:', variant);

    if (!variant || !variant.featured_image) {
      console.log('NO FEATURED IMAGE ON MATCHED VARIANT');
      return;
    }

    var imageId = variant.featured_image.id;

    var $slideshow = $('.product__slideshow').first();
    if (!$slideshow.length) {
      console.log('PRODUCT SLIDESHOW NOT FOUND');
      return;
    }

    var $slide = $slideshow.find(
      '.product__slideshow-slide[data-image-id="' + imageId + '"]'
    );

    console.log('MATCHING SLIDE COUNT:', $slide.length);

    if (!$slide.length) {
      console.log('NO MATCHING SLIDE FOUND');
      return;
    }

    var index = parseInt($slide.attr('data-index'), 10);

    console.log('TARGET SLIDE INDEX:', index);

    if (!isNaN(index) && $slideshow.hasClass('slick-initialized')) {
      console.log('CHANGING SLIDE');
      $slideshow.slick('slickGoTo', index, false);
    }
  }

  $(document).on(
    'change',
    '.form__control input, .form__control select',
    function () {
      setTimeout(updateVariantImage, 50);
    }
  );

})(jQuery);